import React, { Suspense } from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';

import {
  redirectOnUnauthenticatedTenant,
  setTenantLoginRedirectParams,
} from './utils/tenantAuthenticationHelper';
import { getAndSetUtmParameters } from './utils/utmHelper';
import store from './redux/store';
import App from './components/App';
import { unregister } from './registerServiceWorker';
import theme from './utils/Theme';
import './utils/promise-polyfill';

import './index.scss';

const renderApp = () => {
  setTenantLoginRedirectParams();
  redirectOnUnauthenticatedTenant();
  getAndSetUtmParameters();

  render(
    <Suspense fallback={<div />}>
      <MuiThemeProvider theme={theme}>
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <Provider store={store}>
            <Router>
              <App />
            </Router>
          </Provider>
        </MuiPickersUtilsProvider>
      </MuiThemeProvider>
    </Suspense>,
    document.getElementById('root'),
  );
  unregister();
};

if (
  'fetch' in window
  && 'URL' in window
  && 'Map' in window
  && 'forEach' in NodeList.prototype
  && 'startsWith' in String.prototype
  && 'endsWith' in String.prototype
  && 'includes' in String.prototype
  && 'includes' in Array.prototype
  && 'assign' in Object
  && 'entries' in Object
  && 'keys' in Object
) {
  renderApp();
} else {
  import('./utils/polyfills').then(renderApp);
}
